<template>
	<div class="bumper">
		<div class="bumper__content">
			<div>
				<h2
					v-if="titleHighlight"
					class="bumper__green-heading"
					v-html="titleHighlight"
				/>
				<p
					v-if="titleText"
					class="bumper__heading"
					v-html="titleText"
				/>
				<p
					v-if="titleContext"
					class="bumper__context"
					v-html="titleContext"
				/>
			</div>

			<p
				v-for="(paragraph, index) in paragraphs"
				:key="index"
				class="bumper__body"
				v-html="paragraph"
			/>

			<p
				v-if="footerText"
				class="bumper__footer-text"
				v-html="footerText"
			/>

			<div class="bumper__footer">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 39 15"
					class="checkbox__arrow"
					aria-hidden="true"
					role="presentation"
				>
					<path
						fill="#E10000"
						fill-rule="evenodd"
						d="M21.386 1.954A2.016 2.016 0 0 1 23.844.505L37.49 4.033a2.018 2.018 0 0 1 .634 3.617 208.238 208.238 0 0 1-6.446 4.241 77.675 77.675 0 0 1-3.244 1.948c-.224.124-.453.25-.683.371-.984.52-2.069-.086-2.338-1.166l-.07-.278c-.237-.95.273-1.97 1.128-2.449a70.688 70.688 0 0 0 2.817-1.686c-8.952.773-15.24 1.502-19.527 2.123-2.347.34-4.629.781-6.907 1.379-.46.12-1.004-.038-1.344-.538-.156-.229-.486-.804-.798-1.36-.417-.742-.207-1.665.601-1.932a19.11 19.11 0 0 1 1.698-.455c1.385-.316 3.392-.682 6.173-1.085 3.713-.539 8.85-1.15 15.807-1.796l-2.157-.558a2.016 2.016 0 0 1-1.448-2.455Z"
						clip-rule="evenodd"
					/>
				</svg>

				<label class="checkbox">
					<input
						type="checkbox"
						class="checkbox__input"
						:checked="added"
						:disabled="updating || disabled"
						@change="$emit('toggle')"
					/>

					<div
						class="checkbox__outline"
						role="presentation"
						aria-hidden="true"
					>
						<svg
							class="checkbox__check"
							width="30"
							height="25"
							viewBox="0 0 30 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M28.7664 0.766433C29.5744 1.57443 29.5744 2.88446 28.7664 3.69246L7.60203 24.8569L0.835596 18.0904C0.0275961 17.2824 0.0275955 15.9724 0.835596 15.1644C1.6436 14.3564 2.95362 14.3564 3.76162 15.1644L7.60203 19.0048L25.8404 0.766433C26.6484 -0.0415667 27.9584 -0.0415666 28.7664 0.766433Z"
								fill="#E20100"
							/>
						</svg>
					</div>
					Yes! Add to my Order
				</label>
			</div>
		</div>
	</div>
</template>

<script>
import { get } from 'lodash';

export default {
	name: 'ModalBumper',

	props: {
		options: {
			type: Object,
			required: true,
		},
		added: {
			type: Boolean,
			required: true,
		},
		updating: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		titleHighlight() {
			return get(this.options, 'title.highlight', '');
		},
		titleText() {
			return get(this.options, 'title.text', '');
		},
		titleContext() {
			return get(this.options, 'title.context', '');
		},
		paragraphs() {
			return get(this.options, 'body.paragraphs', []);
		},
		footerText() {
			return get(this.options, 'footer.text', '');
		},
	},
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Open+Sans:wght@400;700;800&display=swap');

.bumper {
	font-family: 'Open Sans', sans-serif;
	background: var(--white);
	display: flex;
	gap: var(--size-sm);
	font-size: var(--size-base);
	line-height: 1.4;
	border-bottom: 1px solid var(--gray-300);

	&__heading {
		font-size: var(--size-base);
		font-weight: 700;
		text-transform: uppercase;
		margin-bottom: var(--size-xs);
	}

	&__body {
		color: var(--gray-700);
		font-size: 12px;
		margin: 0;

		&:not(:last-of-type) {
			margin-bottom: var(--size-sm);
		}
	}

	&__footer-text {
		color: var(--gray-700);
		font-size: 12px;
		margin: 0;
	}

	&__green {
		color: var(--green-600);
	}

	&__content {
		padding: var(--size-md) 0;
		flex: 1;

		@media screen and (min-width: 992px) {
			padding: var(--size-md);
		}
	}

	&__footer {
		display: flex;
		gap: var(--size-sm);
		align-items: center;
		margin-top: var(--size-lg);
		position: relative;
	}
}

.checkbox {
	flex: none;
	display: flex;
	gap: var(--size-lg);
	align-self: flex-start;
	border: 1px solid var(--gray-300);
	border-radius: var(--size-xs);
	padding: var(--size-md);
	margin: 0;
	cursor: pointer;
	width: 100%;
	transition: all 300ms ease;
	line-height: 1.5;

	&:hover {
		background: var(--gray-100);
	}

	&:has(input:checked) {
		border-color: var(--red-400);
	}

	&__arrow {
		width: 45px;
		height: var(--size-lg);
		margin-right: var(--size-xs);
		animation: fadeAndGrow 500ms ease-in-out alternate infinite;
		position: absolute;
		left: -45px;
	}

	&__input {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border-width: 0;

		&:focus ~ .checkbox__outline {
			outline: 2px solid var(--red-200);
		}

		&:checked ~ .checkbox__outline > .checkbox__check {
			opacity: 1;
			scale: 1;
		}

		&:disabled ~ .checkbox__outline {
			opacity: 0.65;
		}
	}

	&__outline {
		background: var(--white);
		border-radius: var(--size-xs);
		border: 2px solid var(--gray-700);
		box-shadow: var(--shadow-base);
		height: var(--size-lg);
		width: var(--size-lg);
		position: relative;
	}

	&__check {
		position: absolute;
		opacity: 0;
		scale: 0.8;
		height: 32px;
		left: 3px;
		bottom: 1px;
		transition: all 300ms ease;
		transform-origin: bottom left;
	}
}

@keyframes fadeAndGrow {
	from {
		transform: translateX(0) scale(0.8);
	}

	to {
		transform: translateX(4px) scale(1);
	}
}
</style>
